
import { defineComponent, ref } from 'vue';
import { message } from 'ant-design-vue';
import { formatWithIntl } from '@/utils/illuminate';
import { request } from '@/utils/request';
import { createApiUrl } from '@/utils/utils';
import type { TableColumn } from '@/components/Table';

export default defineComponent({
  name: 'RedFlushDetailModal',
  setup() {
    const visible = ref(false);
    const loading = ref(false);
    const detail = ref<Record<string, any>>({ progress: [] });

    const progressColumns: TableColumn[] = [
      { title: '操作内容', dataIndex: 'operationContent', align: 'center', customRender: ({ text }) => text || '--' },
      { title: '操作时间', dataIndex: 'operationTime', align: 'center', customRender: ({ text }) => text || '--' },
    ];

    const closeModal = () => {
      visible.value = false;
    };

    const open = async (record: any) => {
      visible.value = true;
      detail.value = { progress: [] };
      try {
        loading.value = true;
        const res: any = await request.get(createApiUrl('/newlinkSass/invoice/red-flush-detail'), {
          params: { invoiceRecordId: record.invoiceRecordId },
        });
        detail.value = { progress: [], ...(res.data || {}) };
      } catch (e: Error & any) {
        message.error(e.message);
      } finally {
        loading.value = false;
      }
    };

    return {
      visible,
      loading,
      detail,
      progressColumns,
      formatWithIntl,
      open,
      closeModal,
    };
  },
});
